<template>
  <personalAttendanceSelect :showOperation="true"></personalAttendanceSelect>
</template>

<script>
import personalAttendanceSelect from './personal-attendance-select'
export default {
  name: 'attendanceManagement',
  components: {personalAttendanceSelect}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/system/system/attendance-management.vue